<section id="modulos" class="bg-primary py-24 text-white lg:py-32">
  <div class="site-container">
    <div class="mb-16 flex flex-col justify-between gap-8 border-b border-white/10 pb-8 md:flex-row md:items-end lg:mb-20">
      <div class="max-w-2xl">
        <h2 class="mb-4 text-3xl font-bold text-white lg:text-4xl">{{ content.title }}</h2>
        <p class="text-lg text-navy-200">{{ content.description }}</p>
      </div>
      <a
        appSectionLink="evidencias"
        class="self-start rounded bg-gold px-8 py-3 font-bold text-primary transition-all hover:bg-gold-300 md:self-auto"
      >
        {{ content.cta }}
      </a>
    </div>

    <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      @for (item of content.items; track item.label) {
        <figure
          class="group relative aspect-video overflow-hidden rounded-xl border border-white/10 bg-white/5 transition-all hover:border-gold/50"
        >
          <!-- Mockups ilustrativos: substituir por capturas reais do sistema -->
          <div
            class="absolute inset-0 p-6 opacity-50 transition-transform duration-700 group-hover:scale-105"
            aria-hidden="true"
          >
            @switch (item.mockup) {
              @case ('dashboard') {
                <div class="grid h-full grid-cols-3 grid-rows-2 gap-3">
                  <div class="col-span-2 flex items-end gap-1.5 rounded border border-white/20 p-3">
                    @for (h of [45, 70, 55, 85, 65, 95]; track $index) {
                      <span class="w-full rounded-t-sm bg-navy-300/70" [style.height.%]="h"></span>
                    }
                  </div>
                  <div class="flex items-center justify-center rounded border border-white/20">
                    <span class="flex size-14 items-center justify-center rounded-full border-4 border-gold border-r-white/20 text-xs font-bold">94%</span>
                  </div>
                  <div class="rounded border border-white/20 p-3"><span class="block h-2 w-2/3 rounded bg-white/40"></span></div>
                  <div class="rounded border border-white/20 p-3"><span class="block h-2 w-1/2 rounded bg-white/40"></span></div>
                  <div class="rounded border border-white/20 p-3"><span class="block h-2 w-3/4 rounded bg-gold/60"></span></div>
                </div>
              }
              @case ('documents') {
                <div class="relative mx-auto h-full w-3/5">
                  <div class="absolute inset-0 translate-x-4 -rotate-6 rounded border border-white/20 bg-white/10"></div>
                  <div class="relative flex h-full flex-col gap-2.5 rounded border border-white/30 bg-navy-400/40 p-4">
                    <span class="h-2 w-1/2 rounded bg-white/70"></span>
                    @for (w of ['w-full', 'w-5/6', 'w-full', 'w-2/3', 'w-4/5']; track $index) {
                      <span class="h-1.5 rounded bg-white/40" [class]="w"></span>
                    }
                    <app-icon name="verified" class="mt-auto self-end text-2xl text-gold" />
                  </div>
                </div>
              }
              @case ('education') {
                <div class="flex h-full flex-col justify-center gap-4">
                  @for (course of [80, 55, 100]; track $index) {
                    <div class="flex items-center gap-3">
                      <app-icon name="school" class="text-gold" />
                      <div class="h-2 flex-1 rounded-full bg-white/15">
                        <div class="h-full rounded-full bg-navy-300" [style.width.%]="course"></div>
                      </div>
                    </div>
                  }
                </div>
              }
            }
          </div>
          <figcaption class="absolute inset-0 flex items-end bg-linear-to-t from-primary to-transparent p-6">
            <span class="text-sm font-bold tracking-widest uppercase">{{ item.label }}</span>
          </figcaption>
        </figure>
      }
    </div>
  </div>
</section>
